import React from 'react';

export default function ProgressBar({ progress, height = 'h-3', showLabel = true }) {
  const clampedProgress = Math.min(100, Math.max(0, progress));

  let barColor = 'from-purple-500 to-teal-400';
  if (clampedProgress >= 100) barColor = 'from-green-400 to-emerald-500';
  else if (clampedProgress >= 75) barColor = 'from-teal-400 to-green-400';

  return (
    <div>
      <div className={`w-full bg-gray-200 rounded-full ${height} overflow-hidden`}>
        <div
          className={`${height} rounded-full bg-gradient-to-r ${barColor} animate-fill-bar transition-all duration-500`}
          style={{ width: `${clampedProgress}%` }}
        />
      </div>
      {showLabel && (
        <div className="flex justify-between mt-1">
          <span className="text-xs font-medium text-gray-500">
            {Math.round(clampedProgress)}% paid
          </span>
          {clampedProgress >= 100 && (
            <span className="text-xs font-bold text-green-500">All paid! ✓</span>
          )}
        </div>
      )}
    </div>
  );
}
